import React, { RefObject } from 'react';

import ExplorerIcon from 'components/FileViewer/ExplorerIcon';

import './index.scss';

/**
 * Busca da tela. Não usa o `Searcher` do DS porque precisa do `ref` do input (atalho `/`) e
 * filtra a lista ao digitar, sem a caixa de resultados suspensa do `Searcher`.
 */
export default function SearchBar({
  inputRef,
  value,
  onChange,
  showShortcutHint,
  compact = false,
}: {
  inputRef: RefObject<HTMLInputElement | null>;
  value: string;
  onChange: (value: string) => void;
  showShortcutHint: boolean;
  /** Mobile: placeholder curto, sem o exemplo. */
  compact?: boolean;
}) {
  return (
    <div className="file-explorer-search">
      <ExplorerIcon name="search" size={18} className="file-explorer-search-icon" />
      <input
        ref={inputRef}
        type="search"
        className="file-explorer-search-input"
        aria-label="Buscar arquivos e pastas"
        placeholder={compact ? 'Buscar arquivos e pastas' : 'Buscar arquivos e pastas — ex.: diario 2024 xlsx'}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Escape' && value) {
            event.preventDefault();
            onChange('');
          }
        }}
        autoComplete="off"
        spellCheck={false}
      />
      {value ? (
        <button
          type="button"
          className="file-explorer-search-clear"
          aria-label="Limpar busca"
          title="Limpar (Esc)"
          onClick={() => {
            onChange('');
            inputRef.current?.focus();
          }}
        >
          <ExplorerIcon name="close" size={14} strokeWidth={2.4} />
        </button>
      ) : (
        showShortcutHint && (
          <kbd className="file-explorer-search-kbd" title="Pressione / para buscar">/</kbd>
        )
      )}
    </div>
  );
}
